/* eslint-disable handle-callback-err */
import $ from 'jquery';
import { isNil } from 'lodash';
import Auth0Helpers from '../_helpers/auth0-helpers';
import SessionStorage from '../_helpers/session-storage';
import {
  updateFavoritesListEvent,
  updateDeletedStarEvent,
  updateDeletedStarHeaderEvent,
  updateAddedStarEvent,
  updateAddedStarHeaderEvent,
  addFavoriteButtonClass,
  removeFavoriteButtonClass,
  maxFavoriteModalClass,
  loginModalClass,
  userAccountFavoritesListClass,
  maxFavorites,
  playersRankingsContainerClass,
  playerIdAttribute,
  favoriteTooltipClass,
} from '../_helpers/constants';
import { manageLoader } from '../utils';

export default class PlayerFavorites {
  constructor(elm, opts) {
    this.$element = $(elm);
    this.opts = opts;
    this.auth0Helpers = new Auth0Helpers();
    this.sessionStorage = new SessionStorage();
    this.addFavoriteButtons = null;
    this.removeFavoriteButtons = null;
    this.userData = undefined;

    this.dataContainer = this.$element.parent()[0];

    this.maxfavoritesModal = null;
    this.loginModal = null;

    this.userAccountFavoritesListClass = $(userAccountFavoritesListClass);
    this.isUserAccountPage = false;

    this.addFavoritesText = this.opts.addFavoritesText;
    this.removeFavoritesText = this.opts.removeFavoritesText;
    this.favoriteTooltips = null;
  }

  async updateUserDataSession(userData) {
    try {
      this.sessionStorage.setUserData(userData);
    } catch (e) {}
  }

  async loadUserData() {
    try {
      this.userData = await this.auth0Helpers.getUserFavoritesData();
    } catch (e) {}
  }

  async updateUI() {
    const self = this;
    this.setDefaultTooltipsText(self.favoriteTooltips);
    if (this.userData && this.userData.favoriteplayers) {
      this.userData.favoriteplayers.forEach((item) => {
        this.addStar(item, self);
      });
    }
  }

  getFavoriteButton(buttonElement, buttonClass) {
    if (isNil(buttonElement) || buttonElement.length === 0) {
      return $(buttonClass);
    }
    return buttonElement;
  }

  updateList(res) {
    const data = res.detail.data;
    this.dataContainer.innerHTML = data;
  }

  playerIdEvent(id, event) {
    const updateEvent = new CustomEvent(event, {
      detail: {
        id,
      },
    });
    window.dispatchEvent(updateEvent);
  }

  addStar(item, self) {
    let favorite = self.$element.find(`[data-id='${item}']`);
    if (isNil(favorite) || favorite.length === 0) {
      favorite = $(`[data-id='${item}']`);
    }

    const addButton = $(favorite).find(addFavoriteButtonClass);
    addButton.hide();
    const removeButton = $(favorite).find(removeFavoriteButtonClass);
    removeButton.show();

    const tooltip = favorite.find(favoriteTooltipClass);
    self.changeFavoriteTooltipText(tooltip, self.removeFavoritesText);
  }

  removeStar(item, self) {
    const favorite = self.$element.find(`[data-id='${item}']`);

    const addButton = $(favorite).find(addFavoriteButtonClass);
    addButton.show();
    const removeButton = $(favorite).find(removeFavoriteButtonClass);
    removeButton.hide();

    const tooltip = favorite.find(favoriteTooltipClass);
    self.changeFavoriteTooltipText(tooltip, self.addFavoritesText);
  }

  async updateFunc() {
    await this.loadUserData();

    await this.updateUI();
  }

  getUserAccountPage() {
    return (
      !isNil(this.userAccountFavoritesListClass) && this.userAccountFavoritesListClass.length > 0
    );
  }

  checkMaxFavorites() {
    const favorites = this.sessionStorage.getFavoritePlayers();
    return !!(!isNil(favorites) && favorites.length >= maxFavorites);
  }

  addFavoritePlayer(items, id) {
    if (!isNil(items)) {
      const index = items.indexOf(id);
      if (index === -1) {
        items.push(id);
      }
    } else {
      items = [];
      items.push(id);
    }
    return items;
  }

  deleteFavorite(items, id) {
    const index = items.indexOf(id);
    if (index > -1) {
      items.splice(index, 1);
    }
    return items;
  }

  removeFavoritePlayer(element) {
    if (this.isUserAccountPage) {
      $(element).parent().parent().parent().remove();
    }
  }

  async addFavorite(element, parentElement, updateEvent, maxfavoritesModal, userData) {
    const parent = parentElement;
    const playerId = $(parent).attr(playerIdAttribute);

    if (playerId) {
      // Show Loader
      manageLoader(element, parent);
      if (this.checkMaxFavorites()) {
        $(maxfavoritesModal).show();
        // Hide Loader
        manageLoader(element, parent, null, false, true);
        return userData;
      }

      userData.favoriteplayers = this.addFavoritePlayer(userData.favoriteplayers, playerId);

      const updateResult = await this.auth0Helpers.updateUserData(userData.sub, userData);

      if (!updateResult) {
        // Hide loader
        manageLoader(element, parent, element, false);
        return userData;
      } else {
        this.playerIdEvent(playerId, updateEvent);
        // Hide loader
        const removeButton = $(parent).find(removeFavoriteButtonClass);
        manageLoader(element, parent, removeButton, false);
        await this.updateUserDataSession(userData);

        // Change favourite text
        this.changeFavoriteTooltipText(
          $(parent).find(favoriteTooltipClass),
          this.removeFavoritesText
        );
      }
    }
    return userData;
  }

  async removeFavorite(element, parentElement, updateEvent, userData) {
    const parent = parentElement;
    const playerId = $(parent).attr(playerIdAttribute);

    if (playerId) {
      if (userData.favoriteplayers.length === 0) {
        return userData;
      }
      // Show Loader
      manageLoader(element, parent);

      userData.favoriteplayers = this.deleteFavorite(userData.favoriteplayers, playerId);

      const updateResult = await this.auth0Helpers.updateUserData(userData.sub, userData);

      if (!updateResult) {
        // Hide loader
        manageLoader(element, parent, element, false);
        return userData;
      } else {
        this.playerIdEvent(playerId, updateEvent);
        await this.updateUserDataSession(userData);
        // Hide loader
        const addButton = $(parent).find(addFavoriteButtonClass);
        manageLoader(element, parent, addButton, false);
        // Remove unfavorite player if "EditProfile"
        this.removeFavoritePlayer(element, parent);
        // Change favourite text
        this.changeFavoriteTooltipText($(parent).find(favoriteTooltipClass), this.addFavoritesText);
      }
    }
    return userData;
  }

  setDefaultTooltipsText(favoriteTooltips) {
    favoriteTooltips.html(this.addFavoritesText);
  }

  changeFavoriteTooltipText(item, text) {
    item.html(text);
  }

  setAddFavoriteButton(self, addFavoriteButtons) {
    const addFavoriteButtonsLength = addFavoriteButtons.length;

    $(addFavoriteButtons).prop('onclick', null).off('click');

    let i = 0;

    for (i; i < addFavoriteButtonsLength; i = i + 1) {
      const favItem = addFavoriteButtons[i];
      $(favItem).on('click', async function () {
        const isAuthenticated = await self.auth0Helpers.isAuthenticated();

        if (isAuthenticated) {
          self.userData = await self.addFavorite(
            this,
            $(this).parent(),
            updateAddedStarEvent,
            self.maxfavoritesModal,
            self.userData
          );
        } else {
          $(self.loginModal).show();
        }
      });
    }
  }

  setRemoveFavoriteButton(self, removeFavoriteButtons) {
    const removeFavoriteButtonsLength = removeFavoriteButtons.length;

    $(removeFavoriteButtons).prop('onclick', null).off('click');

    let i = 0;

    for (i; i < removeFavoriteButtonsLength; i = i + 1) {
      const favItem = removeFavoriteButtons[i];
      $(favItem).on('click', async function () {
        self.userData = await self.removeFavorite(
          this,
          $(this).parent(),
          updateDeletedStarEvent,
          self.userData
        );
      });
    }
  }

  async init() {
    this.maxfavoritesModal = $(maxFavoriteModalClass);
    this.loginModal = $(loginModalClass);
    this.auth0Helpers.initModals();

    this.isUserAccountPage = this.getUserAccountPage();

    // Favorites Tooltips
    this.favoriteTooltips = $(playersRankingsContainerClass).find(favoriteTooltipClass);

    await this.updateFunc();

    const self = this;
    // Add Favorites Buttons
    this.addFavoriteButtons = $(playersRankingsContainerClass).find(addFavoriteButtonClass);
    this.setAddFavoriteButton(self, this.addFavoriteButtons);

    // Remove Favorites Buttons
    this.removeFavoriteButtons = $(playersRankingsContainerClass).find(removeFavoriteButtonClass);
    this.setRemoveFavoriteButton(self, this.removeFavoriteButtons);

    document.addEventListener('load-more-event', () => this.init());

    window.addEventListener(updateFavoritesListEvent, (e) => {
      this.updateList(e);
    });

    window.addEventListener(updateDeletedStarHeaderEvent, (e) => {
      if (e.detail && e.detail.id != null) {
        const id = e.detail.id;
        this.removeStar(id, self);
      }
    });

    window.addEventListener(updateAddedStarHeaderEvent, (e) => {
      if (e.detail && e.detail.id != null) {
        const id = e.detail.id;
        this.addStar(id, self);
      }
    });
  }
}
